module.exports = __webpack_public_path__ + "static/media/logo-report-sign.4af8011a.svg";